"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var super_mario_yoshi_image_widget_renderer_1 = __importDefault(require("@bit/super-mario.yoshi.image-widget-renderer"));
var super_mario_yoshi_twitter_widget_renderer_1 = __importDefault(require("@bit/super-mario.yoshi.twitter-widget-renderer"));
var super_mario_yoshi_youtube_widget_renderer_1 = __importDefault(require("@bit/super-mario.yoshi.youtube-widget-renderer"));
var super_mario_yoshi_text_message_renderer_1 = __importDefault(require("@bit/super-mario.yoshi.text-message-renderer"));
var super_mario_yoshi_message_info_renderer_1 = __importDefault(require("@bit/super-mario.yoshi.message-info-renderer"));
var resolver_1 = require("./resolver");
var isYoutubeUrl = function (url) {
    var regex = /((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?/;
    return !!(url && url.match(regex));
};
var isTwitterUrl = function (url) {
    var regex = /https?:\/\/twitter\.com\/(?:#!\/)?(\w+)\/status(es)?\/(\d+)/;
    var res = url && url.match(regex);
    return res && res[3] ? res[3] : null;
};
var isImage = function (text) {
    var imageRegex = /\[image:([a-z0-9\-]+)\]/;
    var imageMatch = text === null || text === void 0 ? void 0 : text.match(imageRegex);
    var image_id = (imageMatch && imageMatch[1]) || null;
    return image_id;
};
var MessageRenderer = function (props) {
    var _a = react_1.useState(null), user = _a[0], setUser = _a[1];
    var text = props.text, userId = props.userId, timestamp = props.timestamp;
    var componentList = [];
    react_1.useEffect(function () {
        if (!user) {
            var fn = function () { return __awaiter(void 0, void 0, void 0, function () {
                var u;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, resolver_1.UserResolver(userId)];
                        case 1:
                            u = _a.sent();
                            u.imageUrl = u.imageUrl || resolver_1.default_profile_photo(u.name, u.id);
                            setUser(u);
                            return [2];
                    }
                });
            }); };
            fn();
        }
    }, []);
    if (user == null)
        return null;
    componentList.push(react_1.default.createElement(super_mario_yoshi_message_info_renderer_1.default, { user: user, timestamp: timestamp }));
    var imageId = isImage(text);
    if (imageId) {
        componentList.push(react_1.default.createElement(super_mario_yoshi_image_widget_renderer_1.default, { id: imageId }));
    }
    else {
        componentList.push(react_1.default.createElement(super_mario_yoshi_text_message_renderer_1.default, { text: text }));
        var regex = /(https?):\/\/[^\s$.?#].[^\s]*/g;
        var urls = text.match(regex) || [];
        urls.forEach(function (url) {
            if (isYoutubeUrl(url)) {
                componentList.push(react_1.default.createElement(super_mario_yoshi_youtube_widget_renderer_1.default, { url: url }));
            }
            else {
                var twitterId = isTwitterUrl(url);
                if (twitterId) {
                    componentList.push(react_1.default.createElement(super_mario_yoshi_twitter_widget_renderer_1.default, { id: twitterId }));
                }
            }
        });
    }
    return (react_1.default.createElement("div", null, componentList.map(function (component, index) { return (react_1.default.createElement("div", { key: index }, component)); })));
};
exports.default = MessageRenderer;
